// localStorage 안전하게 사용하기 위한 유틸리티 함수들

/**
 * localStorage 할당량 초과 에러를 처리하는 안전한 localStorage
 */
export const safeLocalStorage = {
  setItem: (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      if (error instanceof Error && error.name === 'QuotaExceededError') {
        console.warn('localStorage quota exceeded, clearing old data');
        // 현재 키를 제외한 다른 키들 중 일부를 삭제
        const keys = Object.keys(localStorage);
        keys
          .filter((k) => k !== key && k.startsWith('igogo-admin'))
          .slice(0, 3)
          .forEach((k) => {
            localStorage.removeItem(k);
          });
        try {
          localStorage.setItem(key, value);
        } catch (secondError) {
          console.error('Failed to save to localStorage even after cleanup:', secondError);
        }
      } else {
        console.error('Failed to save to localStorage:', error);
      }
    }
  },
};

/**
 * Zustand persist를 위한 안전한 스토리지 설정
 */
export const createSafeStorage = () => ({
  getItem: (name: string) => {
    try {
      const item = localStorage.getItem(name);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Failed to read from localStorage:', error);
      return null;
    }
  },
  setItem: (name: string, value: any) => {
    safeLocalStorage.setItem(name, JSON.stringify(value));
  },
  removeItem: (name: string) => {
    try {
      localStorage.removeItem(name);
    } catch (error) {
      console.error('Failed to remove from localStorage:', error);
    }
  },
});

/**
 * 데이터 크기를 제한하는 partialize 함수 생성기
 * @param maxItems 저장할 최대 항목 수 (기본값: 100)
 */
export const createSizePartialize =
  <T extends { searchResultContainer: { contents: any[] } }>(maxItems: number = 100) =>
  (state: T): T => ({
    ...state,
    searchResultContainer: {
      ...state.searchResultContainer,
      contents: state.searchResultContainer.contents.slice(0, maxItems),
    },
  });

/**
 * 메모리 효율적인 컨테이너 설정 함수
 * 기존의 new Array(result.total) 패턴을 대체
 */
export const createEfficientContainerSetter =
  <T>(containerKey: keyof T) =>
  (result: any) =>
  (state: T): T => {
    // 메모리 효율성을 위해 실제 데이터만 저장
    const newValue = {
      ...(state[containerKey] as any),
      ...result,
      contents: result?.contents || [],
    };
    return { ...state, [containerKey]: newValue } as T;
  };
